
<template>
  <div class="company_contracts">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form_select">
        <div class="select">
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.status"
              :placeholder="translate('services.blocked_simcard.status')"
              :clearable="true"
              :searchable="true"
              @input="change_input"
          />
        </div>

        <div class="select">
          <tree-select
              :options="device_status_list"
              :multiple="false"
              v-model="filter.device_status"
              :placeholder="translate('services.blocked_simcard.device_status')"
              :clearable="true"
              :searchable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select">
        <div class="select">
          <tree-select
              :options="reason_list"
              :multiple="false"
              v-model="filter.reason"
              :placeholder="translate('services.blocked_simcard.reason')"
              :clearable="true"
              :searchable="true"
              @input="change_input"
          />
        </div>
        <div class="select">
          <fg-input
              type="text"
              v-model="filter.fid"
              :placeholder="translate('services.blocked_simcard.device_fid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select">
        <div class="select">
          <tree-select
              :options="simcard_profile_status_list"
              :multiple="false"
              v-model="filter.simcard_profile_status"
              :placeholder="translate('services.blocked_simcard.simcard_profile_status')"
              :clearable="true"
              :searchable="true"
              @input="change_input"
          />
        </div>
        <div class="select"></div>
      </div>

      <div class="form_select"></div>
      <div class="form_select"></div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="Object.keys(tariffication_blocked_simcard_summary).length > 0">
        <p v-for="(sum, key) in tariffication_blocked_simcard_summary" :key="key">
          <span>{{ translate("services.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" class="w60">
              {{ translate('services.blocked_simcard.status') }}
            </th>
            <th scope="col" class="w100">
              {{ translate('services.blocked_simcard.tariff_device_status') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.reason') }}
            </th>
            <th scope="col" class="w100">
              {{ translate('services.blocked_simcard.device_status') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.device') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.tariff') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.mno') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.iccid') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.simcard_profile_status') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.user') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.ts_create') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.ts_update') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.ts_end') }}
            </th>
          </tr>
        </thead>
        <tbody>
            <tr
              v-for="(blocked_simcard, key) in blocked_simcard_list"
              :key="key"
              class="blocked_simcard_item"
              @click="show_blocked_simcard(blocked_simcard)"
            >
              <td :data-label="translate('services.blocked_simcard.status')" class="w60">
                {{ blocked_simcard.status }}
              </td>
              <td :data-label="translate('services.blocked_simcard.tariff_device_status')" class="w100">
                <span
                    v-if="blocked_simcard.tariff_device.status"
                    class="mdi mdi-currency-rub tariffication"
                />
              </td>
              <td :data-label="translate('services.blocked_simcard.reason')" >
                {{ get_reason(blocked_simcard.reason) }}
              </td>
              <td :data-label="translate('services.blocked_simcard.device_status')" class="w100">
                <span
                    v-if="blocked_simcard.tariff_device.device_status"
                    class="mdi mdi-access-point online" >
                </span>
                <span
                    v-else
                    class="mdi mdi-access-point-off offline" >
                </span>
              </td>
              <td :data-label="translate('services.blocked_simcard.device')" @click.stop="" >
                <router-link :to="'/device/' + blocked_simcard.tariff_device.device_fid">
                  {{ blocked_simcard.tariff_device.device_fid }}
                </router-link>
                <p>{{ blocked_simcard.tariff_device.device_name }}</p>
              </td>
              <td :data-label="translate('services.blocked_simcard.tariff_name')">
                {{ blocked_simcard.tariff_device.tariff_name }}
              </td>
              <td :data-label="translate('services.blocked_simcard.mno')" @click.stop="">
                <a v-if="blocked_simcard.simcard_profile.mno_link" :href="blocked_simcard.simcard_profile.mno_link">
                  {{ blocked_simcard.simcard_profile.mno }}
                </a>
                <p v-else>
                  {{ blocked_simcard.simcard_profile.mno }}
                </p>
              </td>
              <td :data-label="translate('services.blocked_simcard.iccid')" @click.stop="">
                <div class="iccid">
                  <router-link :to="'/simcard_devices_list?&msisdn_imsi_iccid=' + blocked_simcard.simcard_profile.iccid">
                    {{ blocked_simcard.simcard_profile.iccid }}
                  </router-link>
                  <span class="mdi mdi-content-copy pointer" @click="copy_iccid(blocked_simcard.simcard_profile.iccid)" />
                </div>
              </td>
              <td :data-label="translate('services.blocked_simcard.simcard_profile_status')">
                <span class="badge" :class="global_status_color(+blocked_simcard.simcard_profile.status)">
                    {{ translate(global_status_text(+blocked_simcard.simcard_profile.status)) }}
                </span>
              </td>
              <td :data-label="translate('services.blocked_simcard.user')">
                {{ blocked_simcard.end_user ? blocked_simcard.user + " / " + blocked_simcard.end_user : blocked_simcard.user }}
              </td>
              <td :data-label="translate('services.blocked_simcard.ts_create')">
                {{ get_date(blocked_simcard.ts_create) }}
              </td>
              <td :data-label="translate('services.blocked_simcard.ts_update')">
                {{ get_date(blocked_simcard.ts_update) }}
              </td>
              <td :data-label="translate('services.blocked_simcard.ts_end')">
                {{ blocked_simcard.ts_end ? get_date(blocked_simcard.ts_end) : "" }}
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ShowBlockedSimCard from "./Modal/ShowBlockedSimCard.vue"

export default {
  name: "BlockedSimcard",
  data() {
    return {
      tariffication_blocked_simcard_list: [],
      tariffication_blocked_simcard_summary: [],
      filter: {
        status: null,
        reason: null,
        simcard_profile_status: null,
        fid: "",
        device_status: null
      },

      filter_asc: "asc",
      filter_type: "",
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    };
  },
  computed: {
    sended_filter(){
      let filter = {}
      for (const filter_key in this.filter) {
        if (this.filter[filter_key] !== null && this.filter[filter_key] !== undefined && this.filter[filter_key] !== "")
        filter[filter_key] = this.filter[filter_key]
      }
      return filter
    },
    blocked_simcard_list(){
      let blocked_simcard_list = [...this.tariffication_blocked_simcard_list]
      return blocked_simcard_list.sort(this.compareNumbers)
    },
    simcard_profile_status_list(){
      return [
        { id: -1, label: this.translate('status_info.undefined') },
        { id: 1, label: this.translate('status_info.active') },
        { id: 2, label: this.translate('status_info.blocked') },
        { id: 3, label: this.translate('status_info.prepare') },
        { id: 4, label: this.translate('status_info.stop') },
      ]
    },
    status_list(){
      return [
        { id: 1, label: this.translate('status_info.active') },
        { id: 0, label: this.translate('status_info.not_active') },
      ]
    },
    device_status_list(){
      return [
        {id: 1, label: this.translate("device_status_list.online")},
        {id: 0, label: this.translate("device_status_list.offline")}
      ]
    },
    reason_list(){
      return this.$store.getters.getBlockedSimcardReason.map((reason) => {
        return {id: reason.id, label: reason.title}
      })
    }
  },

  created() {
    this.check_query()
  },

  activated() {
    this.check_query()
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'tariffication_section' && this.$route.params.tariffication_section === "blocked_simcard") {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'simcard_profile_status':
              case 'status':
              case 'device_status':
              case 'reason':
              case 'fid':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${this.filter[key]}`
                }
                break;
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },

  methods: {
    get_reason(reason_id){
      let reason = this.$store.getters.getBlockedSimcardReason.find((reason) => {
        if (reason.id === reason_id){
          return reason
        }
      })
      return reason ? reason.title : ""
    },
    copy_iccid(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    show_blocked_simcard(blocked_simcard) {
      let t = this.$createElement(ShowBlockedSimCard, {
        props: {
          blocked_simcard_info: blocked_simcard
        },
        on: {
          update: () => {
            this.$modal.hide('show_blocked_simcard')
            this.get_blocked_simcards()
          },
          close: () => {
            this.$modal.hide('show_blocked_simcard')
          },
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'show_blocked_simcard'
      })
    },
    check_query() {
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case 'simcard_profile_status':
            case 'status':
            case 'device_status':
            case 'reason':
            case 'fid':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
      this.get_blocked_simcards()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_blocked_simcards, 500)
    },
    get_blocked_simcards(){
      this.$http.v1.getTarifficationBlockedSimcardList(this.sended_filter, (response) => {
        this.tariffication_blocked_simcard_list = response.data.data
        this.tariffication_blocked_simcard_summary = response.data.summary
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang='scss' scoped>
.company_contracts {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .header {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    margin-bottom: 10px;

    .form_select {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
      .select{
        width: 100%;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        .form-group{
          margin-bottom: 0;
        }
      }
    }

    .checkbox {
      width: 20%;
      margin: 0;
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .response_table{
    flex: 10;
    padding: 0;

    .link{
      width: 30px;
    }
  }

  .blocked_simcard_item {
    font-size: 10px;
    &:hover{
      background-color: #eaeaea;
    }
    a,p{
      font-size: 10px;
      margin-bottom: 0;
    }
    span.mdi{
      font-size: 14px;
      &.online{
        color: #15ab00;
      }
      &.tariffication{
        color: #3f93d3;
      }
    }
    .iccid{
      display: flex;
      justify-content: center;
      align-items: center;
      a{
        margin-right: 5px;
      }
    }
  }

  .summary{
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    margin-bottom: 10px;
    p{
      font-size: 12px;
      line-height: 100%;
      margin-bottom: 0;
    }
    span{
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
      br{
        display: none;
      }
    }
  }

  table {
    height: calc(100% - 55px);
    .active_item {
      background-color: #41b88330;
    }
  }
}

@media (max-width: 768px) {
  .company_contracts {
    .header {
      flex-direction: column;
      flex-wrap: wrap;

      .form_select{
        flex-wrap: wrap;

        .select {
          flex: auto;
          margin-bottom: 10px;
          &:last-child{
            margin-bottom: 10px;
          }
        }
      }

      .checkbox {
        width: 50%;
        margin-bottom: 10px;
        min-width: 100px;
      }

      .button {
        width: 100%;
      }
    }
  }
}
</style>
